import { Link } from "react-router-dom";

function clientOfferPath(url) {
  if (!url) return "";
  try {
    const parsed = new URL(url, window.location.origin);
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch (_err) {
    return url;
  }
}

export default function OfferCard({ offer, onPay, onDecline, showClientOfferAction = false }) {
  if (!offer) return null;
  const money = new Intl.NumberFormat("en-US", { style: "currency", currency: offer.currency || "USD" });
  const total = money.format(Number(offer.total_amount || 0));
  const clientOfferHref = showClientOfferAction ? clientOfferPath(offer.client_offer_url) : "";
  const canShowPay = Boolean(offer.can_pay || (showClientOfferAction && clientOfferHref && ["sent", "viewed"].includes(offer.status)));
  const canShowDecline = Boolean(offer.can_decline ?? ["sent", "viewed", "payment_pending"].includes(offer.status));
  return (
    <article className="offer-message-card">
      <div className="offer-card-top">
        <div>
          <span>Project Offer v{offer.revision_number}</span>
          <h3>{offer.base_plan?.name || "Custom Offer"}</h3>
        </div>
        <strong className={`offer-status offer-status-${offer.status}`}>{offer.status_label || offer.status}</strong>
      </div>
      <div className="offer-card-summary">
        <span>Total</span>
        <strong>{total}</strong>
        <span>Timeline add</span>
        <strong>{offer.estimated_extra_days || "0.0"} days</strong>
      </div>
      <ul>
        {(offer.items || []).slice(0, 5).map((item) => (
          <li key={item.id || item.name}>
            <span>{item.name}</span>
            <strong>{item.is_included ? "Included" : money.format(Number(item.line_total || 0))}</strong>
          </li>
        ))}
      </ul>
      {(clientOfferHref || canShowPay || canShowDecline) && (
        <div className="offer-card-actions">
          {clientOfferHref && <Link to={clientOfferHref}>View Offer</Link>}
          {canShowPay && <button type="button" onClick={() => onPay?.(offer)}>Pay</button>}
          {canShowDecline && <button type="button" className="ghost" onClick={() => onDecline?.(offer)}>Decline</button>}
        </div>
      )}
    </article>
  );
}
